export { default as StrategyProfileResults } from './StrategyProfileResults';
